
import { StoreApi } from 'zustand';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { priceAlertService } from '@/services/priceAlerts/priceAlertService';
import { debugError } from '@/utils/debugLogger';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const togglePriceAlert = async (
  set: SetPriceState,
  get: GetPriceState,
  alertId: string
) => {
  try {
    const state = get();
    const { user, isAuthenticated } = state;
    
    if (!isAuthenticated || !user) {
      debugError('pricing', '[togglePriceAlert] Errore autenticazione', { 
        message: 'Utente non autenticato',
        isAuthenticated,
        hasUser: !!user
      });
      throw new Error('Utente non autenticato');
    }
    
    // Trova l'avviso corrente per determinare il nuovo stato
    const currentAlert = state.priceAlerts.find(alert => 
      alert.id === alertId && alert.userId === user.id
    );
    
    if (!currentAlert) {
      throw new Error('Avviso non trovato');
    }
    
    const newActiveState = !currentAlert.isActive;
    
    // Aggiorna nel database
    const success = await priceAlertService.toggleAlert(alertId, user.id, newActiveState);
    
    if (!success) {
      throw new Error('Impossibile aggiornare l\'avviso nel database');
    }
    
    // Aggiorna lo store locale
    set((state: PriceState & UserState) => {
      const updatedAlerts = state.priceAlerts.map(alert => {
        if (alert.id === alertId && alert.userId === user.id) {
          return { ...alert, isActive: newActiveState };
        }
        return alert;
      });
      
      return { priceAlerts: updatedAlerts };
    });
  } catch (error) {
    debugError('pricing', '[togglePriceAlert] Error toggling price alert', { 
      error: error instanceof Error ? error.message : String(error), 
      alertId,
      userId: get().user?.id 
    });
    throw error;
  }
};
